import { render, staticRenderFns } from "./DataSelection.vue?vue&type=template&id=15e464b8"
import script from "./DataSelection.vue?vue&type=script&lang=js"
export * from "./DataSelection.vue?vue&type=script&lang=js"
import style0 from "./DataSelection.vue?vue&type=style&index=0&id=15e464b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports